import { useGuaziSiteConfig } from '@/hooks/guaziUseSiteConfig';

export default function GuaziHero() {
  const { config } = useGuaziSiteConfig();

  return (
    <section id="home" className="guazi-anchor relative w-full overflow-hidden bg-background-50 pt-[88px] md:pt-[100px]">
      {/* 背景图 */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="/images/guazi-hero-bg.jpg"
          alt="瓜子影视官方推广站背景"
          title="瓜子影视APP下载官网"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-transparent to-background-50" />
      </div>

      <div className="relative w-full px-4 md:px-6 pb-16 md:pb-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-8">
          {/* 左侧文字 */}
          <div className="w-full lg:w-[56%] pt-8 md:pt-12 guazi-fade-up">
            <h1 className="font-heading font-extrabold text-foreground-950 leading-[1.05] text-[52px] sm:text-6xl md:text-7xl lg:text-[80px] tracking-tight">
              瓜子影视
            </h1>

            <p className="mt-5 text-lg md:text-2xl font-bold text-foreground-800">
              瓜子影视APP下载官网 —— 海量高清影视，随时随地畅享
            </p>

            <p className="mt-5 text-sm md:text-base leading-7 md:leading-8 text-foreground-600 max-w-2xl">
              瓜子影视是一款清爽流畅的影视播放软件，电影、电视剧、综艺、动漫、纪录片一站看齐。想要快速上手，请认准瓜子影视APP下载官网；苹果用户查看瓜子影视iOS官网最新下载安装，电视大屏用户选择瓜子影视TV版2026官方最新版下载，一步到位畅享大屏观影。
            </p>

            {/* 下载按钮（首页下载按钮 2/2） */}
            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <a
                href={config.downloadPagePath}
                className="inline-flex items-center justify-center gap-2 px-7 md:px-9 py-3.5 md:py-4 bg-primary-500 text-primary-950 text-base font-extrabold rounded-md hover:bg-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-xl" />
                立即下载瓜子影视
              </a>
              <div className="flex items-center gap-2 px-4 py-3 rounded-md bg-background-100 border border-background-200">
                <i className="ri-shield-check-line text-primary-600 text-lg" />
                <span className="text-sm text-foreground-700">官方正版 · 安全无广告捆绑</span>
              </div>
            </div>

            {/* 支持平台 */}
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <span className="text-sm text-foreground-500">支持平台</span>
              <span className="px-3 py-1.5 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-800 whitespace-nowrap">Android</span>
              <span className="px-3 py-1.5 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-800 whitespace-nowrap">iOS</span>
              <span className="px-3 py-1.5 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-800 whitespace-nowrap">HarmonyOS</span>
              <span className="px-3 py-1.5 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-800 whitespace-nowrap">TV版</span>
            </div>

            {/* 数据 */}
            <div className="mt-9 flex flex-wrap items-center gap-x-8 gap-y-4">
              <div>
                <div className="font-heading font-extrabold text-2xl md:text-3xl text-primary-600">100万+</div>
                <div className="text-xs md:text-sm text-foreground-500">影视资源</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-2xl md:text-3xl text-accent-500">4K</div>
                <div className="text-xs md:text-sm text-foreground-500">高清画质</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-2xl md:text-3xl text-secondary-600">4端</div>
                <div className="text-xs md:text-sm text-foreground-500">同步畅享</div>
              </div>
            </div>
          </div>

          {/* 右侧吉祥物 */}
          <div className="w-full lg:w-[44%] relative flex items-center justify-center min-h-[320px] md:min-h-[460px]">
            <div className="absolute w-[240px] h-[240px] md:w-[360px] md:h-[360px] rounded-full bg-primary-200 guazi-pulse-soft" />
            <img
              src="/images/guazi-mascot-1.png"
              alt="瓜子影视吉祥物"
              title="瓜子影视APP下载官网"
              className="relative w-[260px] md:w-[400px] guazi-float"
            />
            <div className="absolute top-4 right-2 md:right-6 flex items-center gap-2 px-3 py-2 bg-background-50 border border-background-200 rounded-lg">
              <i className="ri-flashlight-line text-primary-500 text-lg" />
              <span className="text-xs md:text-sm font-bold text-foreground-800">秒开秒播</span>
            </div>
            <div className="absolute bottom-6 left-2 md:left-6 flex items-center gap-2 px-3 py-2 bg-background-50 border border-background-200 rounded-lg">
              <i className="ri-movie-2-line text-accent-500 text-lg" />
              <span className="text-xs md:text-sm font-bold text-foreground-800">蓝光画质</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}